import React from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { ASSETS, CONTACT } from "@/data";
import { Reveal, SectionLabel, CTAButton, requestInquiry } from "@/components/site/ui";

const STATS = [
  { value: "30+", label: "Years of Experience" },
  { value: "1990s", label: "Practising Since" },
  { value: "CICC", label: "Member in Good Standing" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-36 bg-[#F5F5F7]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative grain overflow-hidden bg-charcoal aspect-[3/4] max-w-md">
              <img
                src={ASSETS.portrait}
                alt="Ali Sleiman, Regulated Canadian Immigration Consultant"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              href={CONTACT.cicc}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cicc-verify-link"
              className="mt-6 flex items-center gap-4 max-w-md group transition-colors"
            >
              <img
                src={ASSETS.insignia}
                alt="RCIC Insignia"
                className="h-16 w-auto shrink-0"
              />
              <span className="text-sm text-charcoal group-hover:text-crimson transition-colors leading-snug inline-flex items-start gap-2">
                Verify Status with the College of Immigration and Citizenship Consultants
                <ExternalLink size={14} className="mt-0.5 shrink-0" />
              </span>
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <SectionLabel>About</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-heading font-bold text-charcoal text-4xl lg:text-6xl tracking-tight leading-[1.02]">
              Ali Suliman Sleiman
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-2xl">
              With over 30 years of experience and trusted expertise navigating
              Canada&rsquo;s evolving immigration landscape, we didn&rsquo;t just learn
              the rules yesterday — we have watched the Canadian immigration
              system evolve since the 1990s. We provide trusted, knowledgeable,
              and personalized immigration guidance to individuals, families,
              and professionals looking to build their future in Canada.
            </p>
          </Reveal>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-black/10 pt-10">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={0.25 + i * 0.1}>
                <div>
                  <p className="font-heading font-extrabold text-crimson text-3xl lg:text-5xl tracking-tight">
                    {s.value}
                  </p>
                  <p className="mt-2 text-xs sm:text-sm uppercase tracking-wider text-muted-foreground">
                    {s.label}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.5}>
            <div className="mt-12">
              <CTAButton
                testid="about-book-btn"
                onClick={() => requestInquiry("consultation")}
              >
                Book a Consultation
              </CTAButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
